"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FEATURE_FLAG = void 0;
// TODO(2fd): add Docs
const react_1 = require("react");
const feature_flags_1 = require("@dcl/feature-flags");
const FeatureFlags_1 = __importDefault(require("../utils/development/FeatureFlags"));
const useAsyncState_1 = __importDefault(require("./useAsyncState"));
exports.DEFAULT_FEATURE_FLAG = new FeatureFlags_1.default({
    flags: {},
    variants: {},
});
function useFeatureFlag(options) {
    const [ff, asyncState] = (0, useAsyncState_1.default)(async () => {
        if (!options.applicationName) {
            return exports.DEFAULT_FEATURE_FLAG;
        }
        const ff = await (0, feature_flags_1.fetchFlags)(options);
        return new FeatureFlags_1.default(ff);
    }, [
        options.applicationName,
        options.debug,
        options.featureFlagsUrl,
        options.userId,
    ], {
        initialValue: exports.DEFAULT_FEATURE_FLAG,
    });
    const isEnabled = (0, react_1.useCallback)(
    /** @deprecated use ff.enabled(KEY) instead */
    (key) => {
        return (!!ff &&
            !!options.applicationName &&
            !!ff.flags[`${options.applicationName}-${key}`]);
    }, [ff]);
    const getVariantName = (0, react_1.useCallback)(
    /** @deprecated use ff.name(KEY) instead */
    (key, defaultVariant) => {
        var _a;
        if (isEnabled(key)) {
            const variant = ff.variants[`${options.applicationName}-${key}`];
            if ((_a = variant.payload) === null || _a === void 0 ? void 0 : _a.value) {
                return variant.payload.value;
            }
        }
        return defaultVariant !== null && defaultVariant !== void 0 ? defaultVariant : null;
    }, [ff]);
    const getVariantValue = (0, react_1.useCallback)(
    /** @deprecated use ff.payload(KEY) instead */
    (key, defaultVariant) => {
        var _a;
        if (isEnabled(key)) {
            const variant = ff.variants[`${options.applicationName}-${key}`];
            if ((_a = variant.payload) === null || _a === void 0 ? void 0 : _a.value) {
                return variant.payload.value;
            }
        }
        return defaultVariant !== null && defaultVariant !== void 0 ? defaultVariant : null;
    }, [ff]);
    const state = (0, react_1.useMemo)(() => ({
        ...asyncState,
        isEnabled,
        getVariant: getVariantValue,
        getVariantValue,
        getVariantName,
    }), [asyncState, isEnabled, getVariantName, getVariantValue]);
    return [ff, state];
}
exports.default = useFeatureFlag;
